import useSuperUserHook from '~hooks/useSuperUserHook';

export function useUserId() {
  const session = useSuperUserHook();
  return session?.data?.userId as string;
}
